import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import {
  removeLayout,
  renameTab,
  setLayouts,
  setTeamLayoutEditMode,
} from "./redux/actions/layoutActions";
import { Trans, withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import FormatColourFillIcon from "@material-ui/icons/FormatColorFill";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";
import AddIcon from "@material-ui/icons/Add";
import PeopleIcon from "@material-ui/icons/People";
import InfoIcon from "@material-ui/icons/Info";
import SpeedDial from "@material-ui/lab/SpeedDial";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import ColourPickerDialog from "./components/dialog/ColourPickerDialog";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import AreYouSureDialog from "./components/dialog/AreYouSureDialog";
import ElementWrapper from "./components/ElementWrapper";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import {
  Responsive as ResponsiveGridLayout,
  WidthProvider,
} from "react-grid-layout";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import CreatePortletDialog from "./components/dialog/CreatePortletDialog";
import { editTheme } from "./redux/actions/themeActions";
import { createMuiTheme } from "@material-ui/core/styles";
import FilterWrapper from "./components/filter/FilterWrapper";
import TeamPicker from "./components/TeamPicker.js";
import Portal from "@material-ui/core/Portal";
import axios from "./AxiosClient";
import { taxServiceClient } from "./AxiosClient";
import PubSub from "pubsub-js";
import {
  PORTLET_LAYOUT,
  SET_LAYOUTS,
  PORTLET_LAYOUT_ADD,
  PORTLET_LAYOUT_DELETE,
  LAYOUT_ADD,
  LAYOUT_DELETE,
  LAYOUT_UPDATE,
  LAYOUT,
  PORTLET_LAYOUT_UPDATE,
} from "./utils/Topics";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import EditLayoutElement from "./components/EditLayoutElement";
import { withSnackbar } from "notistack";
import ActionButton from "./components/ActionButton";
import { Role, currentUserHasRole } from "./utils/RoleUtils";
import KpsTextField from "./components/KpsTextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Paper from "@material-ui/core/Paper";

const WidthAwareGridLayout = WidthProvider(ResponsiveGridLayout);
const gridNumColumns = { lg: 6, md: 3, sm: 2, xs: 1, xxs: 1 };
const portletsNotAvailableToMobile = [
  "com.kpsol.api.apicommon.content.KnowledgeItemInterface",
];
const styles = (theme) => ({
  loader: {
    margin: "15px auto",
    display: "block",
  },
  portletContainer: {
    display: "flex",
    position: "relative",
  },
  textField: {
    marginTop: 5,
  },
  speedDial: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 9999999999,
  },
  fab: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  speedDialAction: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  teamSwitch: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(12),
    zIndex: 9999999998,
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1),
    paddingRight: theme.spacing(2),
    color: theme.palette.secondary.contrastText,
  },
  alert: {
    width: "fit-content",
    marginLeft: "auto",
    marginRight: "auto",
    position: "fixed",
    bottom: theme.spacing(3),
    zIndex: 9999999998,
  }
});

let droppables = {};
export class CardLayout extends Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    layout: PropTypes.object.isRequired,
    // url: PropTypes.string.isRequired,
    layoutId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    onFullscreen: PropTypes.func.isRequired,
    gridLayout: PropTypes.object.isRequired,
    //setFullscreen: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.templateRef = React.createRef();
    this.state = {
      dataLoaded: false,
      portlets: [],
      canSort: true,
      createNewDialogOpen: false,
      changeTitleDialogOpen: false,
      changeColoursDialogOpen: false,
      createNewPortletDialogOpen: false,
      shareDialogOpen: false,
      newLayoutTitle: "",
      editedLayoutTitle: "",
      themeId: 1,
      layoutMenuAnchor: null,
      speedDialOpen: false,
      deleteConfirmOpen: false,
      compactType: "horizontal",
      layout: this.props.layout.gridLayout,
      layoutBeforeFullscreen: null,
      hasFullscreen: false,
      droppables: {},
      added: false,
      portletAddedId: null,
      showFilters: false,
      filterAnchorEl: null,
      filterElement: null,
      filters: null,
      onFilterChange: null,
      filterTitle: "",
      showReset: true,
      currentBreakpoint: "lg",
      filterInstance: "",
      selectedTeam: null,
      layouts: [],
      fullscreenPortletId: null,
      shareLayoutSaving: false,
      wasFullscreen: false,
      changedPortlets: [],
      shareConfirmNeeded: false,
      objectClass: "",
      layoutBeforeAdd: null,
      notAvailableToTeamsList:[],
      resizingPortlet: -1,
    };
    this.toggleFilters = this.toggleFilters.bind(this);
    this.updateFilters = this.updateFilters.bind(this);
    this.closeFilters = this.closeFilters.bind(this);
  }

  componentDidMount() {
    this.getLayout();
    this.portletToken = PubSub.subscribe(
      PORTLET_LAYOUT,
      this.portletSubscriber
    );
  }

  componentWillUnmount() {
    PubSub.unsubscribe(this.portletToken);
  }

  portletSubscriber = (msg, data) => {
    switch (msg) {
      case PORTLET_LAYOUT_ADD:
        if (data.layoutId === this.props.layoutId) {
          axios
            .get(
              `/portalLayout/${this.props.layoutId}/portlet/${data.portletId}`,
              { withCredentials: true }
            )
            .then((res) => {
              //A copy of the layout before you add the portlet is needed because the GridLayout itself puts it in an odd place, and its easier to control using the previous layout.
              this.setState({
                portlets: [res.data, ...this.state.portlets],
                layoutBeforeAdd: { ...this.state.layout },
                added: true,
                portletAddedId: data.portletId,
              });
            });
        }
        break;
      case PORTLET_LAYOUT_DELETE:
        let newArray = this.state.portlets.slice(0);
        this.state.portlets.forEach((portlet, idx) => {
          if (data.portletId === portlet.id) {
            newArray.splice(idx, 1);
          }
        });
        this.setState({ portlets: newArray });
        break;
      case PORTLET_LAYOUT_UPDATE:
        if (data.portlet.portalLayoutID === this.props.layoutId) {
          if (
            this.props.layout.layoutType === "team" &&
              currentUserHasRole(Role.TEAM_LEADER)
          ) {
            if (this.state.changedPortlets.indexOf(data.portlet.id) === -1) {
              this.setState({
                changedPortlets: [
                  ...this.state.changedPortlets,
                  data.portlet.id,
                ],
              });
            }
            // this.alertUnsavedChanges();
          }
          let updated = JSON.parse(JSON.stringify(this.state.portlets));
          updated = updated.map((portlet) => {
            if (portlet.id === data.portlet.id) {
              if (!data.portlet.layout) {
                data.portlet.layout = '{"lg":[]}';
              }
              return data.portlet;
            }
            return portlet;
          });
          let updatedFilter = updated.filter(u => u.instance === this.state.filterInstance)
          if (updated && updatedFilter.length > 0) {
            let newfilters = JSON.parse(updatedFilter[0].parameters)
            let showReset =
              (updatedFilter[0].originalMenuPortlet &&
              updatedFilter[0].originalMenuPortlet.parameters) 
              ?
              !this.areEqual(newfilters,JSON.parse(
                updatedFilter[0].originalMenuPortlet.parameters
              ))
              : false
        
            if (!this.areEqual(newfilters,this.state.filters)) {
              this.setState({ portlets: updated, filters: newfilters, showReset: showReset});
            }
          } else {
            this.setState({ portlets: updated});
          }
        }
        break;
      default:
        break;
    }
  };
  findParentOfTopic = (topicNode) =>{
    //Trying to write it seperately to simplify it for my brain
    //We get every taxonmy node with this topic as a direct child
    let taxWithThisTopic = this.props.taxonomyNodeLookup.filter(item=>{
      if(item.type=="taxonomy" && item.children!=null){
        return item.children.find(child=>{
          if(child.type=="topic" && child.id==topicNode.id){
            return true;
          }
        })
      }
    });
    // We now want every taxonomy node from that list who has every parent the topic has.
    let filtered = taxWithThisTopic.filter(tax=>{
      //We need this to make sure that there are no parents left over, if there are then its the wrong parent
      let copyOfParentsList = [...topicNode.parentList];
      //this should always be true
      if(topicNode.parentList.includes(tax.id)){
        //For each node the topic has, does the taxonomy node also contain it?
        topicNode.parentList.forEach(parentTaxId=>{
          if(parentTaxId!=tax.id){
           if(tax.parentList.includes(parentTaxId)){
           //remove from list
            const index = copyOfParentsList.indexOf(parentTaxId);
              if (index > -1) { 
                copyOfParentsList.splice(index, 1);
              }
            }
          } else {
            //remove from list
            const index = copyOfParentsList.indexOf(parentTaxId);
            if (index > -1) { 
              copyOfParentsList.splice(index, 1);
            }
          }
        }) 
      } 
      if (copyOfParentsList.length === 0){
        return true;
      }
    })
    return filtered;
  }

  getListOfFilterTaxonomyIds = () => {
    let filteredPortlets = this.state.portlets.filter(p => {
      if (p.parameters && p.parameters !== "null") {  
        let params = JSON.parse(p.parameters) 
        if (params.taxonomy && params.taxonomy.length > 0) {
          return true
        }
      } else return false
      
    })
    let mapped = filteredPortlets.map(p => {
      let params = JSON.parse(p.parameters) 
      let layoutDetails = this.state.layout.lg ? this.state.layout.lg.filter(l => l.i === '' + p.id) : [{x: -1,y: -1}]
      let newTaxonomy =[];
      params.taxonomy.forEach(node=>{
        if(node.type=="taxonomy"){
          newTaxonomy.push(node.id);
        } else if (node.type=="topic"){
          let tax = this.findParentOfTopic(node);
          tax != null && tax.length > 0 && newTaxonomy.push(tax[0].id);
        }
      })

      return params && params.taxonomy ?
        { id: p.id, 
          title: (p.originalMenuPortlet && p.originalMenuPortlet.title)
            ? this.props.t(p.title)
            : p.title,
          icon: p.icon,
         // taxonomyIds: [...params.taxonomy.map(t => t.id)],
         taxonomyIds: newTaxonomy,
          x: layoutDetails && layoutDetails.length > 0 ? layoutDetails[0].x / layoutDetails[0].w : -1,
          y: layoutDetails && layoutDetails.length > 0 ? layoutDetails[0].y : -1,
        }
        : {}
    })
    return mapped
  };

  componentDidUpdate(prevProps) {
    if (this.props.gridLayout !== prevProps.gridLayout) {
      // TODO: Need to revisit this logic as mapping state->props is an anti-pattern
      if (!this.state.hasFullscreen) {
        this.setState({ layout: this.props.gridLayout });
      }
    }
    if (this.props.loaded !== prevProps.loaded || 
      (this.props.teamLayoutEditMode === true && prevProps.teamLayoutEditMode === false)) {
      this.getLayout();
    }
  }

  render() {
    const { classes, t } = this.props;
    // let portlets = [...this.state.portlets];
    // if (this.props.isMobile) {
    //   portlets = portlets.filter((portlet) => {
    //     return !portletsNotAvailableToMobile.includes(portlet.objectClass);
    //   });
    // }
    return (
      <div
        style={{
          height: "100%",
          display: this.props.selected ? "block" : "none",
        }}
      >
        {!this.state.dataLoaded || !this.props.selected ? (
          <CircularProgress className={classes.loader} size="300px" />
        ) : (
          <div className={classes.portletContainer} ref={this.templateRef}>
            <Portal container={document.getElementById("layout-container")}>
              {this.props.currentLayout.layoutType === "team" &&
                          currentUserHasRole(Role.TEAM_LEADER) &&
                <Paper elevation={10} square={false} className={classes.teamSwitch}>
                  <FormControlLabel
                    value="bottom"
                    control={
                      <>
                        <Switch
                          checked={this.props.teamLayoutEditMode}
                          onChange={this.setTeamLayoutEditMode}
                          color="secondary"
                          name="EditTeamLayout"
                          inputProps={{ 'aria-label': 'Edit Team Layout' }}
                        />
                      </>
                    }
                    label="Edit Team Layout"
                    labelPlacement="start"
                    // className={classes.teamSwitch}
                  />
                </Paper>
              }
              {this.props.selected &&
                this.props.currentUser.userType !== "limited" && (
                  <SpeedDial
                    id="card-layout-speed-dial"
                    classes={{ fab: classes.fab }}
                    ariaLabel="Create new layout"
                    className={classes.speedDial}
                    icon={
                      (
                        <AddIcon />
                      )
                    }
                    onBlur={this.handleSpeedDialClose}
                    onClick={this.handleSpeedDialClick}
                    onClose={this.handleSpeedDialClose}
                    onFocus={this.handleSpeedDialOpen}
                    onMouseEnter={this.handleSpeedDialOpen}
                    onMouseLeave={this.handleSpeedDialClose}
                    open={this.state.speedDialOpen}
                    FabProps={{disabled:this.state.notAvailableToTeamsList.length !==0 && this.props.teamLayoutEditMode === true}}
                  >
                    {this.props.currentLayout.layoutType === "team" &&
                      this.props.currentLayout.creator !==
                        this.props.currentUser.userId && (
                        <SpeedDialAction
                          key="create_user_version"
                          icon={<PersonAddIcon />}
                          tooltipTitle={<Typography>{t("app_bar_create_user_version")}</Typography>}
                          onClick={this.createUserVersion}
                        />
                      )}
                    <SpeedDialAction
                      key="edit_colours"
                      ariaLabel={t("app_bar_change_layout_colours")}
                      aria-label={t("app_bar_change_layout_colours")}
                      classes={{ button: classes.speedDialAction }}
                      icon={<FormatColourFillIcon />}
                      tooltipTitle={<Typography>{t("app_bar_change_layout_colours")}</Typography>}
                      onClick={this.toggleChangeColoursDialog}
                      disabled={
                        this.props.currentLayout.layoutType === "team" &&
                        // this.props.currentLayout.creator !==
                        //   this.props.currentUser.userId &&
                        (!currentUserHasRole(Role.TEAM_LEADER) ||
                        this.props.teamLayoutEditMode === false)
                      }
                    />
                    <SpeedDialAction
                      ariaLabel={t("app_bar_delete_layout")}
                      aria-label={t("app_bar_delete_layout")}
                      key="delete_layout"
                      classes={{ button: classes.speedDialAction }}
                      disabled={
                        this.props.currentLayout.layoutType === "team" &&
                        // this.props.currentLayout.creator !==
                        //   this.props.currentUser.userId &&
                        (!currentUserHasRole(Role.TEAM_LEADER) ||
                        this.props.teamLayoutEditMode === false)
                      }
                      icon={<DeleteIcon />}
                      tooltipTitle={<Typography>{t("app_bar_delete_layout")}</Typography>}
                      onClick={this.toggleDeleteConfirmDialog}
                    />
                    <SpeedDialAction
                      ariaLabel={t("app_bar_edit_layouts")}
                      aria-label={t("app_bar_edit_layouts")}
                      key="edit_layouts"
                      classes={{ button: classes.speedDialAction }}
                      icon={<CreateIcon />}
                      tooltipTitle={<Typography>{t("app_bar_edit_layouts")}</Typography>}
                      disabled={
                        this.props.currentLayout.layoutType === "team" &&
                        // this.props.currentLayout.creator !==
                        //   this.props.currentUser.userId &&
                        (!currentUserHasRole(Role.TEAM_LEADER) ||
                        this.props.teamLayoutEditMode === false)
                      }
                      onClick={this.toggleChangeTitleDialog}
                    />
                    <SpeedDialAction
                      key="share_layout"
                      ariaLabel={t("app_bar_share_layout")}
                      aria-label={t("app_bar_share_layout")}
                      classes={{ button: classes.speedDialAction }}
                      disabled={!currentUserHasRole(Role.TEAM_LEADER)}
                      icon={<PeopleIcon />}
                      tooltipTitle={<Typography>{t("app_bar_share_layout")}</Typography>}
                      onClick={this.toggleShareDialog}
                    />
                    <SpeedDialAction
                      key="add_new_portlet"
                      ariaLabel={t("app_bar_add_new_portlet")}
                      aria-label={t("app_bar_add_new_portlet")}
                      classes={{ button: classes.speedDialAction }}
                      disabled={
                        this.props.currentLayout.layoutType === "team" &&
                        // this.props.currentLayout.creator !==
                        //   this.props.currentUser.userId &&
                        (!currentUserHasRole(Role.TEAM_LEADER) ||
                        this.props.teamLayoutEditMode === false)
                      }
                      icon={<AddToPhotosIcon />}
                      tooltipTitle={<Typography>{t("app_bar_add_new_portlet")}</Typography>}
                      onClick={this.toggleCreateNewPortletDialog}
                    />
                  </SpeedDial>
                )}
            </Portal>
            <DragDropContext onDragEnd={this.onDragEnd}>
              <WidthAwareGridLayout
                compactType={this.state.compactType}
                cols={gridNumColumns}
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                rowHeight={400}
                isDraggable={
                  // this.props.currentLayout.creator ===
                  // this.props.currentUser.userId &&
                  (this.props.currentLayout.layoutType === "user" ||
                  currentUserHasRole(Role.TEAM_LEADER) &&
                  this.props.teamLayoutEditMode == true)
                }
                isResizable={
                  // this.props.currentLayout.creator ===
                  // this.props.currentUser.userId &&
                  (this.props.currentLayout.layoutType === "user" ||
                  currentUserHasRole(Role.TEAM_LEADER) &&
                  this.props.teamLayoutEditMode == true)
                }
                style={{ width: "100%" }}
                layouts={this.state.layout}
                draggableHandle=".handle"
                onLayoutChange={this.onLayoutChange}
                onBreakpointChange={this.setBreakpoint}
                onResizeStart={(layout, oldItem, newItem, placeholder, e, element) => {
                  this.setState({resizingPortlet: parseInt(newItem.i)})
                }}
                onResizeStop={(layout, oldItem, newItem, placeholder, e, element) => {
                  this.setState({resizingPortlet: -1})
                }}
              >
                {this.state.portlets.map((portlet) => {
                  let layout = {};
                  if (this.state.layout[this.state.currentBreakpoint]) {
                    layout = this.state.layout[
                      this.state.currentBreakpoint
                    ].filter((ele) => ele.i == portlet.id)[0];
                  }
                  if (!layout || !layout.h) {
                    layout = { h: portlet.fullscreen === true ? 2 : 1, w: 2, minW: 2, x: 0, y: 0 };
                  } else if (layout.h === 1 && portlet.fullscreen) {
                    // if the layout has this portlet with a height of 1 and its fullscreen then the change to the 
                    // number of rows caused by this makes the CardList call the backend multiple times leading to cancelled xhr requests
                    // layout.h = 2
                  }
                  return (
                    <div key={portlet.id}>
                      <ElementWrapper
                        listRef={(ref) => {
                          droppables[`droppable-${portlet.id}`] = ref;
                        }}
                        key={portlet.instance}
                        setFullscreen={this.setFullscreen}
                        fullscreen={
                          !this.props.isMobile &&
                          this.state.fullscreenPortletId === portlet.id &&
                          this.state.currentBreakpoint != "xs"
                        }
                        cansort={this.state.canSort}
                        height={layout.h === 1 && portlet.fullscreen ? 2 * 400 : layout.h * 400}
                        rows={layout.h === 1 && portlet.fullscreen ? 2 : layout.h}
                        width={layout.w}
                        portlet={portlet}
                        toggleFilters={this.toggleFilters}
                        updateFilters={this.updateFilters}
                        setFilterInstance={this.setFilterInstance}
                        filters={this.state.filters}
                        resizing={this.state.resizingPortlet === portlet.id}
                      />
                    </div>
                  );
                  // }
                })}
              </WidthAwareGridLayout>
            </DragDropContext>
          </div>
        )}
        {this.state.hasFullscreen !== true && (
          <FilterWrapper
            asPopper={true}
            open={this.state.showFilters}
            onClose={this.closeFilters}
            anchorEl={this.state.filterAnchorEl}
            filterElement={this.state.filterElement}
            filter={this.state.filters}
            onFilterChange={this.state.onFilterChange}
            isFilterBar={false}
            title={this.state.filterTitle}
            showReset={this.state.showReset}
            resetToDefaultFilters={this.state.resetToDefaultFilters}
            filterInstance={this.state.filterInstance}
            objectClass={this.state.objectClass}
            isMobile={this.props.isMobile}
          />
        )}
        {this.state.createNewDialogOpen && (
          <Dialog
            open={this.state.createNewDialogOpen}
            onClose={this.handleCreateDialogClosed}
            aria-labelledby="create-new-dialog-title"
            aria-describedby="create-new-dialog-description"
          >
            <DialogTitle id="create-new-dialog-title">
              <Trans i18nKey="card_layout_create_new" />
            </DialogTitle>
            <DialogContent id="create-new-dialog-description">
              <TextField
                autoFocus
                aria-label={t("layout_title")}
                className={classes.textField}
                onChange={(e) =>
                  this.setState({ newLayoutTitle: e.target.value })
                }
                defaultValue={this.props.title}
                label={t("global_document_title")}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCreateDialogClosed} color="primary">
                <Trans i18nKey="global_cancel" />
              </Button>
              <Button onClick={this.createNewLayout} color="primary">
                <Trans i18nKey="global_create" />
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.changeTitleDialogOpen && (
          <Dialog
            open={this.state.changeTitleDialogOpen}
            onClose={this.handleChangeTitleDialogClosed}
            aria-labelledby="edit-title-dialog-title"
          >
            <DialogTitle id="edit-title-dialog-title">
              <Trans i18nKey="change_text_edit_layout_title" />
            </DialogTitle>
            <DialogContent id="edit-title-dialog-description">
              <DragDropContext onDragEnd={this.onLayoutDragEnd}>
                <Droppable
                  direction="horizontal"
                  droppableId="top-droppable"
                  type="top"
                  renderClone={(provided, snapshot, rubric) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card>
                        <CardHeader
                          avatar={
                            <span
                              className="mdi mdi-drag-vertical"
                              style={{ fontSize: "1.5rem" }}
                            />
                          }
                          title={
                            <KpsTextField
                              className={classes.textField}
                              value={
                                this.state.layouts[rubric.source.index].title
                              }
                              label={t("global_document_title")}
                            />
                          }
                        />
                      </Card>
                    </div>
                  )}
                >
                  {(dropProvided, dropSnapshot) => (
                    <>
                      <div
                        className={classes.drawerContents}
                        ref={dropProvided.innerRef}
                        {...dropProvided.droppableProps}
                        style={{ flexDirection: "row", display: "flex" }}
                      >
                        {this.state.layouts.map((layout, index) => (
                          <EditLayoutElement
                            changeLabel={this.changeLabel}
                            key={layout.id}
                            index={index}
                            handleDrop={this.handleItemDrop}
                            layout={layout}
                          />
                        ))}
                        {dropProvided.placeholder}
                      </div>
                    </>
                  )}
                </Droppable>
              </DragDropContext>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleChangeTitleDialogClosed}
                color="primary"
                autoFocus
              >
                <Trans i18nKey="global_cancel" />
              </Button>
              <Button onClick={this.saveNewTitlesAndOrder} color="primary">
                <Trans i18nKey="global_save" />
              </Button>
            </DialogActions>
          </Dialog>
        )}
        <ColourPickerDialog
          open={this.state.changeColoursDialogOpen}
          onClose={this.handleChangeColoursDialogClosed}
          onSubmit={this.changeLayoutColours}
        />
        {this.state.shareDialogOpen && (
          <Dialog
            open={this.state.shareDialogOpen}
            onClose={this.handleShareDialogClosed}
            aria-labelledby="share-dialog-title"
            aria-describedby="share-dialog-description"
          >
            <DialogTitle id="share-dialog-title">
              <Trans i18nKey="share_layout_header" />
            </DialogTitle>
            <DialogContent id="share-dialog-description">
              <TeamPicker
                getListOfFilterTaxonomyIds={this.getListOfFilterTaxonomyIds}
                onTeamUsersUpdate={this.onTeamSelected}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleShareDialogClosed} color="primary">
                <Trans i18nKey="global_cancel" />
              </Button>
              <ActionButton
                loading={this.state.shareLayoutSaving}
                onClick={this.shareLayout}
                color="primary"
              >
                {t("global_save")}
              </ActionButton>
            </DialogActions>
          </Dialog>
        )}
        {this.state.deleteConfirmOpen && (
          <AreYouSureDialog
            open={this.state.deleteConfirmOpen}
            onClose={this.toggleDeleteConfirmDialog}
            onSubmit={this.deleteLayout}
          >
            <Trans i18nKey="confirm_delete_portlet_list" />
          </AreYouSureDialog>
        )}
        {this.state.createNewPortletDialogOpen && (
          <CreatePortletDialog
            instance={this.state.instance}
            layoutId={this.props.layoutId}
            handleSubmit={this.addPortlet}
            onClose={this.handleCreateNewPortletDialogClosed}
            open={this.state.createNewPortletDialogOpen}
            addPortlet={true}
          />
        )}
        {this.state.shareConfirmNeeded && (
          <AreYouSureDialog
            open={this.state.shareConfirmNeeded}
            onClose={() => this.setState({ shareConfirmNeeded: false })}
            onSubmit={this.shareLayoutConfirmed}
          >
            This layout has content portlet and if whom you share it with is not
            an expert, they will not be able to see it.
          </AreYouSureDialog>
        )}
      </div>
    );
  }
  changeLabel = (label, id) => {
    let layouts = [...this.state.layouts];
    layouts.forEach((layout) => {
      if (layout.id === id) {
        layout.title = label;
      }
    });
    this.setState({ layouts });
  };

  onTeamSelected = (team) => {
    this.setState({ selectedTeam: team });
  };

  onLayoutDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    let list = Array.from(this.state.layouts);
    const [removed] = list.splice(source.index, 1);
    list.splice(destination.index, 0, removed);
    this.setState({ layouts: list });
  };

  onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    let layouts = [...this.state.layouts];
    if (source.droppableId === destination.droppableId) {
      droppables[destination.droppableId].reorderList(
        source.index,
        destination.index
      );
    } else {
      let removed = droppables[source.droppableId].removeFromList(source.index);
      droppables[destination.droppableId].addToList(destination.index, removed);
    }

    if (result.type === "top") {
      const [removed] = layouts.splice(result.source.index, 1);
      layouts.splice(result.destination.index, 0, removed);
      layouts.forEach((ele, idx) => (ele.orderNumber = idx));
      this.setState({ layouts });
    }
  };

  setBreakpoint = (breakpoint) => {
    this.setState({ currentBreakpoint: breakpoint });
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  addPortlet = (portlet) => {
    PubSub.publish(PORTLET_LAYOUT_ADD, {
      layoutId: this.props.currentLayout.id,
      portletId: portlet.id,
    });
    this.handleCreateNewPortletDialogClosed();
  };

  setTeamLayoutEditMode = (e) => {
    // we are turning editing on, however we need to clear any taxonomy 
    // filters have changed as they can be updated while editing is off, and could 
    // be unsuitable for the target team this happens in componentDidUpdate

    this.props.setTeamLayoutEditMode(!this.props.teamLayoutEditMode)
  }

  setFullscreen = (fullscreen, portlet) => {
    document.querySelector(".swipeable-slide").scrollTop = 0;
    this.setState({ hasFullscreen: fullscreen });
    if (fullscreen) {
      //if fullscreen already exists
      if (this.state.layoutBeforeFullscreen && this.state.fullscreenPortletId) {
        let newLayout = JSON.parse(
          JSON.stringify(this.state.layoutBeforeFullscreen)
        );
        //revert the layout to what it was before anything was fullscreen
        this.setState({ layout: this.state.layoutBeforeFullscreen }, () => {
          //and after that has happened fullscreen the new portlet
          this.makePortletFullscreen(portlet);
        });
      } else {
        // if a fulllscreen does not already exist save the current layout as layoutBeforeFullscreen
        this.setState({ layoutBeforeFullscreen: this.state.layout }, () => {
          this.makePortletFullscreen(portlet);
        });
      }
    } else {
      //if stopping a fulscreen reuse previous layout and null the fullscreenportletid
      this.setState({ wasFullscreen: true }, () => {
        this.setState({
          layout: this.state.layoutBeforeFullscreen,
          fullscreenPortletId: null,
        });
      });
    }
    // save the portlet
    // axios.patch(`/portalLayout/${this.props.layoutId}/portlet/${portlet.id}`, {
    //   ...portlet,
    //   fullscreen,
    // });
    this.props.onFullscreen(fullscreen, this.props.layoutId);
  };

  makePortletFullscreen = (portlet) => {
    let newLayout = JSON.parse(JSON.stringify(this.state.layout));
    //then make the correct portlet fullscreen
    newLayout[this.state.currentBreakpoint] = newLayout[
      this.state.currentBreakpoint
    ].map((ele) => {
      if (ele.i == portlet.id) {
        return {
          ...ele,
          w: gridNumColumns[this.state.currentBreakpoint],
          h: 2,
          x: 0,
          y: 0,
        };
      } else {
        return { ...ele, y: ele.y + 2 };
      }
    });
    //save the new layout and portletid
    this.setState({ layout: newLayout, fullscreenPortletId: portlet.id });
  };

  onLayoutChange = (e, layout) => {
    // this.setState({resizingPortlet: -1})
    if (this.state.hasFullscreen) return;
    if (this.areEqual(layout, this.state.layout)) return;
    let newLayout = null;
    if (Object.keys(this.state.layout).length === 0) {
      newLayout = JSON.parse(JSON.stringify(layout));
    } else {
      newLayout = JSON.parse(JSON.stringify(this.state.layout));
    }
    //if a new portlet was just added
    if (this.state.added) {
      // use the previous layout from before the portlet was added
      let layoutArray = this.state.layoutBeforeAdd[
        this.state.currentBreakpoint
      ];
      //get the new portlet from the current layout so the data is perfectly in the right format
      let newPortletLayoutObject = e.filter(
        (item) => item.i == this.state.portletAddedId
      )[0];
      layoutArray.unshift(newPortletLayoutObject);
      for (var i = 0; i < layoutArray.length; i++) {
        let tempObject = Object.assign({}, layoutArray[i]);
        //move that new portlet and give it the right settings
        if (tempObject.i == this.state.portletAddedId) {
          tempObject.w = 2;
          tempObject.x = 0;
          tempObject.y = 0;
          tempObject.minW = 2;
          let portlet = this.state.portlets.filter(
            (p) => p.id == this.state.portletAddedId
          )[0];
          if (portlet && portlet.elementType === "CardStats") {
            tempObject.minW = 3;
            tempObject.w = 3;
          } else if (
            portlet &&
            portlet.objectClass ===
              "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface"
          ) {
            tempObject.minW = 6;
            tempObject.w = 6;
            tempObject.h = 2;
          }
          //Not sure why we have this. Removed it with 0 testing.
          // if (typeof newLayout === "String") {
          //   newLayout = JSON.parse(newLayout);
          // }
          //add the new portlet layout object to the start of the layout array
          newLayout[this.state.currentBreakpoint].unshift(tempObject);
        } else {
          //if not the new portlet, then we gotta move everything
          //Due to the odd way the Gridlayout works, it puts the previous item at y:0, x:2, to x:3, so we only need to add 1.
          if (tempObject.x == 3 && tempObject.y == 0) {
            tempObject.x++;
          } else {
            //move everything else 2 to the right
            tempObject.x = tempObject.x + 2;
          }
          //if the item is now over the edge, move it down a row, x to 0. Slight bit of fudging, as it might not be 100 percent right, but the Gridlayout will fix it itself.
          if (
            tempObject.x + tempObject.w >
            gridNumColumns[this.state.currentBreakpoint]
          ) {
            tempObject.x = 0;
            tempObject.y = tempObject.y + 1;
          }
          //Then the new portlet needs to be at the start of that array for it to work.
          let index = newLayout[this.state.currentBreakpoint].findIndex(
            (fred) => fred.i == tempObject.i
          );
          newLayout[this.state.currentBreakpoint].splice(index, 1);
          newLayout[this.state.currentBreakpoint].unshift(tempObject);
        }
      }
      layout = newLayout;
      this.setState({ added: false });
    }
    this.setState({ layout });
    this.props.setLayouts(
      this.props.layouts.map((propLayout) => {
        if (propLayout.id === this.props.layoutId) {
          return {
            ...propLayout,
            gridLayout: layout,
          };
        }
        return propLayout;
      })
    );
    //N.B. limited users do not have permision to patch a layout
    if (((this.props.layout.layoutType === "user") && !currentUserHasRole(Role.LIMITED_USER)) || 
        (this.props.teamLayoutEditMode === true &&
          this.props.currentLayout.layoutType === "team" &&
          currentUserHasRole(Role.TEAM_LEADER)
          // (this.props.currentLayout.creator ===
          //   this.props.currentUser.userId)
            )) {
      axios.patch(`/portalLayout/${this.props.layoutId}`, {
        id: this.props.layoutId,
        gridLayout: JSON.stringify(layout),
      });
    }
    // } else {
    //   if (!this.state.wasFullscreen && this.props.currentLayout.layoutType === "team") {
    //     // this.alertUnsavedChanges();
    //   }
    // }
    if (this.state.wasFullscreen) {
      this.setState({ wasFullscreen: false });
    }
  };
  areEqual = (object1, object2) => {
    var equal = require("deep-equal");
    return equal(object1, object2) ? true : false;
  };

  changeLayoutColours = (primary, secondary) => {
    this.props.editTheme(
      createMuiTheme({
        typography: {
          useNextVariants: true,
        },
        palette: {
          primary: {
            main: primary,
          },
          secondary: {
            main: secondary,
          },
        },
      })
    );
    axios
      .patch(`/portalLayout/${this.props.layoutId}`, {
        id: this.props.layoutId,
        primaryColour: primary,
        secondaryColour: secondary,
      })
      .then((res) => {
        PubSub.publish(LAYOUT_UPDATE, {
          layoutId: this.props.layoutId,
          layout: res.data,
        });
      });
    this.handleChangeColoursDialogClosed();
  };

  deleteLayout = () => {
    this.toggleDeleteConfirmDialog();
    axios.delete(`/portalLayout/${this.props.layoutId}`).then((res) => {
      PubSub.publish(LAYOUT_DELETE, { layoutId: this.props.layoutId });
      this.props.removeLayout();
    });
  };

  createUserVersion = (e) => {
    e.stopPropagation();
    axios
      .post("/portalLayout/", {
        ...this.props.currentLayout,
        id: null,
        layoutType: "user",
        layout: this.state.portlets,
        gridLayout: JSON.stringify(this.props.layout.gridLayout),
      })
      .then(() => {
        this.props.enqueueSnackbar(
          this.props.t("user_layout_created_successfully"),
          {
            variant: "success",
          }
        );
      })
      .catch((err) => {
        this.props.enqueueSnackbar(this.props.t("error_creating_user_layout"), {
          variant: "error",
        });
      });
  };

  shareLayout = () => {
    let results = this.state.portlets.filter(
      (portlet) =>
        portlet.objectClass ===
        "com.kpsol.api.apicommon.content.KnowledgeItemInterface"
    );
    if (results.length > 0) {
      this.setState({ shareConfirmNeeded: true });
    } else {
      this.shareLayoutConfirmed();
    }
  };
  shareLayoutConfirmed = () => {
    this.setState({ shareConfirmNeeded: false });
    let teamIds = this.state.selectedTeam.map((e) => {
      return e.teamId;
    });
    this.setState({ shareLayoutSaving: true });
    axios
      .post("/portalLayout/", {
        ...this.props.currentLayout,
        id: null,
        layoutType: "team",
        teams: teamIds,
        layout: this.state.portlets,
        gridLayout: JSON.stringify(this.props.layout.gridLayout),
      })
      .then(() => {
        this.props.enqueueSnackbar(this.props.t("layout_shared_successfully"), {
          variant: "success",
        });
        this.setState({ shareLayoutSaving: false });
        this.handleShareDialogClosed();
      })
      .catch((err) => {
        this.props.enqueueSnackbar(this.props.t("error_sharing_layout"), {
          variant: "error",
        });
        this.setState({ shareLayoutSaving: false });
      });
  };

  handleSpeedDialClick = (e) => {
    this.toggleCreateNewLayoutDialog(e);
  };

  handleSpeedDialOpen = () => {
    this.setState({ speedDialOpen: true });
  };

  handleSpeedDialClose = () => {
    this.setState({ speedDialOpen: false });
  };

  openMenu = (event) => {
    this.setState({ layoutMenuAnchor: event.currentTarget });
  };

  toggleDeleteConfirmDialog = (e) => {
    e && e.stopPropagation();
    this.setState((prev) => ({ deleteConfirmOpen: !prev.deleteConfirmOpen }));
  };

  closeLayoutMenu = () => {
    this.setState({ layoutMenuAnchor: null });
  };

  toggleCreateNewLayoutDialog = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({
      createNewDialogOpen: !prev.createNewDialogOpen,
    }));
  };

  handleCreateDialogClosed = () => {
    this.setState({ createNewDialogOpen: false });
  };

  toggleChangeTitleDialog = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({
      layouts: this.props.layouts,
      changeTitleDialogOpen: !prev.changeTitleDialogOpen,
    }));
  };

  handleChangeTitleDialogClosed = () => {
    this.setState({ layouts: [], changeTitleDialogOpen: false });
  };

  toggleChangeColoursDialog = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({
      changeColoursDialogOpen: !prev.changeColoursDialogOpen,
    }));
  };

  handleChangeColoursDialogClosed = () => {
    this.setState({ changeColoursDialogOpen: false });
  };

  toggleCreateNewPortletDialog = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({
      createNewPortletDialogOpen: !prev.createNewPortletDialogOpen,
    }));
  };

  handleCreateNewPortletDialogClosed = () => {
    this.setState({ createNewPortletDialogOpen: false });
  };

  toggleShareDialog = (e) => {
    e.stopPropagation();
    this.setState((prev) => ({ shareDialogOpen: !prev.shareDialogOpen }));
  };

  handleShareDialogClosed = () => {
    this.setState({ shareDialogOpen: false });
  };

  saveNewTitlesAndOrder = () => {
    let layouts = [...this.state.layouts];
    layouts.forEach((layout, idx) => {
      if (typeof layout.gridLayout !== "string") {
        layout.gridLayout = JSON.stringify(layout.gridLayout);
      }
      layout.orderNumber = idx + 1;
    });
    axios.patch(`/portalLayout/`, layouts).then((res) => {
      var layouts = res.data;
      layouts.forEach((item, pos) => {
        item.loaded = false;
        if (!item.gridLayout) item.gridLayout = '{"lg":[]}';
        item.gridLayout = JSON.parse(item.gridLayout);
      });
      this.props.setLayouts(layouts);
    });
    this.handleChangeTitleDialogClosed();
  };

  createNewLayout = () => {
    this.handleCreateDialogClosed();
    let layout = JSON.parse(JSON.stringify(this.props.currentLayout));
    layout.gridLayout = JSON.stringify(layout.gridLayout);
    axios
      .post("/portalLayout/", {
        ...layout,
        title: this.state.newLayoutTitle,
        layoutType: "user",
        themeId: this.state.themeId,
        gridLayout: '{"lg":[]}',
      })
      .then((res) => {
        PubSub.publish(LAYOUT_ADD, { layoutId: res.data.id, layout: res.data });
      });
  };

  getLayout() {
    if (this.props.loaded) {
      // if (!this.state.instance) {
      //   this.setState({ instance: new Date().getTime().toString() });
      // }
      axios
        .get(`/portalLayout/${this.props.layoutId}/portlet/`, {
          withCredentials: true,
        })
        .then((res) => {
          let portlets = res.data.map((ele) => {
            if (!ele.layout) {
              ele.layout = '{"lg":[]}';
            }
            return ele;
          });
          this.setState({ portlets }, () => {
            this.setState({ dataLoaded: true });
          });
        });
    }
  }
  toggleFilters(
    anchorEl,
    filterElement,
    filters,
    onFilterChange,
    filterTitle,
    showReset,
    resetToDefaultFilters,
    instance,
    objectClass
  ) {
    var filter = this.state.showFilters;
    anchorEl === this.state.filterAnchorEl && this.state.showFilters === true
      ? (filter = false)
      : (filter = true);

    this.setState(
      {
        filters: filters,
        showFilters: filter,
        filterAnchorEl: anchorEl,
        filterElement: filterElement,
        onFilterChange: onFilterChange,
        filterTitle: filterTitle,
        showReset: showReset,
        resetToDefaultFilters: resetToDefaultFilters,
        filterInstance: instance,
        objectClass: objectClass,
      },
      () => {}
    );
  }
  setFilterInstance = (instance) => {
    this.setState(
      {
        filterInstance: instance,
      },
      () => {}
    );
  };
  updateFilters(filters, showReset, instance) {
    if (!this.areEqual(filters,this.state.filters)) {
      if (filters.taxonomy && filters.taxonomy.length > 0 && 
          (!this.state.filters || !this.state.filters.taxonomy || !this.areEqual(filters.taxonomy,this.state.filters.taxonomy))) {        
          filters.taxonomy.filter(t => t.type === "taxonomy").length > 0 &&
            this.taxonomyFilterTeamLayoutCheck(filters.taxonomy.filter(t => t.type === "taxonomy").map(t => t.id))
      }
      this.state.filterInstance === instance ||
      this.state.filterInstance === "" &&
        this.setState({
          filters: filters,
          showReset: showReset,
          // unsavedChangesAlert: true,
        });
    }
  }
  taxonomyFilterTeamLayoutCheck = (taxonomyIds) => {
    if ((this.props.currentLayout.layoutType === "team") &&
      this.props.currentLayout.teamPortals) {
      let teamIds = this.props.currentLayout.teamPortals.map(tp => tp.teamId)
        let url = "/team/taxonomyfilter/check"
        taxServiceClient
          .get(url, {
            params: {
              taxIds: taxonomyIds,
              teamIds: teamIds
            },
          }).then((res) => { 
            let unavailableToTeams = res.data && res.data.length > 0 
              ? res.data.filter(t => t.available === false)
              : []
            this.setState({notAvailableToTeamsList: unavailableToTeams})
          })
    }  }

  closeFilters() {
    this.setState((prev) => ({ showFilters: false }));
  }
}

const mapStateToProps = (state) => ({
  canEdit: state.layout.edit,
  deletePortletInstance: state.layout.deletePortletInstance,
  currentLayout: state.layout.currentLayout,
  layouts: state.layout.layouts,
  currentUser: state.user.currentUser,
  titles: state.layout.tabs,
  isMobile: state.screen.isMobile,
  teamLayoutEditMode: state.layout.teamLayoutEditMode,
  taxonomyNodeLookup: state.taxonomy.taxonomyNodeLookup,
});

const mapDispatchToProps = {
  removeLayout,
  renameTab,
  editTheme,
  setLayouts,
  setTeamLayoutEditMode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(withSnackbar(CardLayout))));
